import React, { useState } from "react";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Dialog from "@mui/material/Dialog";
import { useEffect } from "react";
import "./rejectModal.scss";
import {
  AppBar,
  DialogActions,
  DialogContent,
  Slide,
  TextField,
  Toolbar,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Buttons from "../../Controls/Buttons/Button";
import Draggable from "react-draggable";
import Paper from "@mui/material/Paper";

// Slide transition
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function PaperComponent(props) {
  return (
    <Draggable
      handle=".draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

// Component
export default function ModalProcessor(props) {
  const {
    disableMarkAsResolve,
    modalOpen,
    handleClose,
    handleReject,
    isShowClearButton,
    rejectionContent,
    isReadOnly,
    markAsResolve,
    heading,
    disableFooterBtns,
    rows,
    hideFooterBtns,
    handleDelete,
    isShowDeleteButton,
  } = props;

  const [comment, setComment] = useState(rejectionContent);

  useEffect(() => {
    setComment(rejectionContent);
  }, [rejectionContent]);

  return (
    <div>
      <Dialog
        fullWidth
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        size="lg"
        className="reject-modal"
        TransitionComponent={Transition}
        PaperComponent={PaperComponent}
      >
        <AppBar className="appbar" position="static" elevation={0}>
          <Toolbar
            className="appbar draggable-dialog-title "
            sx={{
              minHeight: "50px !important",
              padding: "0 6px",
              cursor: "move",
            }}
          >
            <Typography variant="h6" sx={{ flex: 1 }}>
              {heading}
            </Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose}>
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <DialogContent className="processor-dailogContent-modal">
          <TextField
            multiline
            minRows={rows} // Minimum number of visible rows
            fullWidth
            variant="outlined"
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            // disabled={isReadOnly}
            placeholder="Enter your remark here..."
            sx={{ marginTop: 2 }}
            inputProps={{
              readOnly: isReadOnly,
            }}
          />
        </DialogContent>

        <DialogActions>
          <div className="btn-wrap">
            {!isReadOnly ? (
              <>
                {isShowDeleteButton && (
                  <div>
                    <Buttons
                      className="reject-btn"
                      variant="outlined"
                      text="Delete"
                      disabled={
                        comment === undefined ||
                        comment === "" ||
                        disableFooterBtns
                      }
                      onClick={(e) => handleDelete(comment)}
                    />
                  </div>
                )}
                <div>
                  {isShowClearButton && (
                    <Button
                      type="button"
                      className="clear-btn"
                      variant="outlined"
                      onClick={(event) => setComment("")}
                    >
                      Clear
                    </Button>
                  )}
                </div>
                <div>
                  <Buttons
                    type="button"
                    className="reject-btn"
                    variant="outlined"
                    text="Submit"
                    disabled={
                      comment === undefined ||
                      comment === "" ||
                      disableFooterBtns
                    }
                    onClick={(e) => handleReject(comment)}
                  />
                </div>
              </>
            ) : hideFooterBtns === true ? (
              ""
            ) : (
              <div className="reject-btn-wrap">
                <Buttons
                  className="reject-btn"
                  variant="outlined"
                  onClick={(e) => markAsResolve()}
                  disabled={disableMarkAsResolve || disableFooterBtns}
                  text={"Resolve"}
                />
              </div>
            )}
          </div>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// Default Props
ModalProcessor.defaultProps = {
  isShowClearButton: false,
  isReadOnly: false,
  isShowDeleteButton: false,
  heading: "Do you really want to reject?",
  rows: 5,
  hideFooterBtns: false,
};
